import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //src: 'https://localhost:7020',
    //subDirectory: '',
    //src: 'https://chacha.thinker.tw',
    //subDirectory: '/Core',
    src: 'https://chacha.tainan.gov.tw',
    subDirectory: '/Core',
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
